import React, {Component} from 'react'
import PropTypes from 'prop-types'

import styles from './WaProgressBar.less'

const {
    'loading': loading_class,
    'bar-wrapper': bar_wrapper_class,
    'bar-inner': bar_inner_class,
} = styles

export default class WaProgressBar extends Component {
    render() {
        const {className, description, is_completed, complete_message, loading_image} = this.props

        if (is_completed) {
            return (
                <div>{complete_message}</div>
            )
        }

        const bar_wrapper_classes = [bar_wrapper_class]

        const bar_inner_styles = {
            width: this.getBarInnerWidth()
        }

        return (
            <div className={className}>
                <div className={`progressbar blue float-left ${bar_wrapper_classes.join(' ')}`}>
                    <div className="progressbar-outer">
                        <div className={`progressbar-inner ${bar_inner_class}`} style={bar_inner_styles}/>
                    </div>
                </div>
                <i className="fas fa-spinner wa-animation-spin"></i>
                <div>
                    <div className={styles['description']}>{description}</div>
                    <div className="small italic">
                        Не закрывайте окно браузера и не покидайте страницу до тех пор, пока процесс экспорта не будет
                        завершен.
                    </div>
                </div>
            </div>
        )
    }

    getBarInnerWidth = () => {
        const {progress, is_completed} = this.props
        if (is_completed) {
            return '100%'
        }

        const progress_float = parseFloat(progress)

        if (isNaN(progress_float) || progress_float < 0) {
            return '0%'
        }

        if (progress_float > 100) {
            return '100%'
        }

        return `${progress_float}%`
    }
}

WaProgressBar.propTypes = {
    progress: PropTypes.any,
    description: PropTypes.any,
    complete_message: PropTypes.any,
    is_completed: PropTypes.any
}
